import { Link } from 'react-router-dom';
import './HomeBanner.css';
import heroBg from '../../assets/figma_hero_bg.jpg';
import heroBannerVideo from '../../assets/hero_banner.mp4';
import heroProduct from '../../assets/hero_product.png';

export default function HomeBanner() {
  return (
    <section className="hero">
      <video
        className="hero-bg-video"
        src={heroBannerVideo}
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="hero-overlay" />
      <div className="hero-container">

        {/* ── Left: headline + CTA ── */}
        <div className="hero-left">
          <h1 className="hero-eyebrow">Power Your Melbourne Home with Solar &amp; Battery</h1>
          <h2 className="hero-title">
            Stop Overpaying for Electricity
          </h2>
          <p className="hero-desc">
            <strong>Watt &amp; Wattle</strong> designs custom solar &amp; battery systems for Australian homes,
            helping you cut energy bills and take control.
          </p>
          <Link to="/contact" className="hero-cta-btn">
            Get free quote
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14M12 5l7 7-7 7" stroke="#050b14" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <div className="hero-stars">
            <div className="hero-star-icons">
              {[...Array(5)].map((_, i) => (
                <svg key={i} width="28" height="28" viewBox="0 0 24 24" fill="#eaff50">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
              ))}
            </div>
            <span>Rated 5 stars by Melbourne homeowners</span>
          </div>
        </div>

        {/* ── Right: product image ── */}
        <div className="hero-right">
          <div className="hero-glow" />
          <img src={heroProduct} alt="Solar Panel & Battery System" className="hero-img-product" />
        </div>

      </div>
    </section>
  );
}
